module.exports = __webpack_public_path__ + "img/v_logo_new.f266dd05.png";